import { createSlice } from "@reduxjs/toolkit";
import { setValue } from "../context/contextSlice";
import { createPanelState } from "./utils/data-utils";
const initialState = {
  open: false,
  header: [],
  body: [],
  footer: [],
};

export const panelSlice = createSlice({
  name: "panel",
  initialState,
  reducers: {
    open: (state, { payload }) => {
      state.open = true;
    },
    close: (state, { payload }) => {
      state.open = false;
    },
    toggle: (state, { payload }) => {
      state.open = !state.open;
    },
    updatePanel: (
      state,
      { payload: { header = [], body = [], footer = [] } = {} }
    ) => {
      state.header = header;
      state.body = body;
      state.footer = footer;
    },
    updateHeader: (state, { payload }) => {
      state.header = payload;
    },
    updateBody: (state, { payload }) => {
      state.body = payload;
    },
    updateFooter: (state, { payload }) => {
      state.footer = payload;
    },
  },
});

export const {
  open,
  close,
  toggle,
  updatePanel,
  updateBody,
  updateHeader,
} = panelSlice.actions;

export const selectOpen = (state) => state.panel.open;
export const selectHeader = (state) => state.panel.header;
export const selectBody = (state) => state.panel.body;
export const selectFooter = (state) => state.panel.footer;

export default panelSlice.reducer;

export const panelMiddleware = (store) => (next) => (action) => {
  const { type, payload } = action;

  if (type === "context/toggleTopic") {
    const state = store.getState();
    if (
      state?.panel?.open &&
      state?.context?.tractor?.state?.topic === payload
    ) {
      next(close());
    } else {
      next(open());
    }
  }

  next(action);

  if (type.match("context/") || type === "@@INIT" || type === "panel/open") {
    next(updatePanel(createPanelState(store.getState())));
  }

  if (type === "panel/close") {
    next(setValue({ path: "tractor/topic", value: null }));
  }
};
